<template>
    <div class="card is-small" :class="{'inactive' : !active, 'collapsed': !driversAccordionOpen }">
        <header class="card__header" @click="toggleExpandDrivers">
            <div class="card__header__icon">
                <svg class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
            </div>
            <div class="card__header__text">
                <p class="text-regular">{{driver.name}}</p>
            </div>
        </header>
        <div class="card__body" @click="toggleExpandDrivers">
            <ul>
                <li v-for="(subDriver,index) in driver.children" :key="subDriver.name + '-driver-card'" :class="{'text-muted' : !subDriver.selected}">{{subDriver.name}}</li>
            </ul>
            <span class="toggle-hint" v-if="driver.selected && this.$store.getters.isMobile">Hide</span>
            <span class="toggle-hint" v-if="!driver.selected && this.$store.getters.isMobile">Show</span>
            <toggle-button v-if="this.$store.getters.isMobile" class="toggle is-green" :color="getColor(driver.color)" :value="driver.selected" :sync="true" @change="toggleDriver" />
        </div>

        <div class="card__footer">
            <toggle-button v-if="!this.$store.getters.isMobile" class="is-green" :color="getColor(driver.color)" :value="driver.selected" :sync="true" @change="toggleDriver" />
            <action-menu v-if="active" @removeFromFeed="toggleDriver" v-bind:driverId="driver.id" @toggle="menuActive = !menuActive"></action-menu>
        </div>
    </div>
</template>

<script>
    import router from '../router.js';
    import Icon from './Icon';
    import EventBus from '../eventbus.js';
    import ActionMenu from './ActionMenu';

    export default {
        props : [
            'driver',
            'driversAccordionOpen',
            'expandDriversParent'
        ],
        data : function() {
            return {
                active: false,
                menuActive: false
            }
        },
        created() {
        },
        watch: {
            menuActive(value) {
                $(this.$el).parent().toggleClass('active');
            }
        },
        computed: {
            colors() {
                return this.$store.getters.colors;
            }
        },
        mounted() {
            this.active = this.driver.selected;
        },
        methods : {
            getColor(color) {
                let colorName = color.split('-');
                return this.colors[colorName[1]];
            },
            toggleDriver() {
                this.driver.selected = !this.driver.selected;
                this.active = this.driver.selected;
                this.menuActive = false;

                EventBus.$emit('portal.toggleDriver', true);
            },
            toggleExpandDrivers(e) {
                if ( !$(e.target).hasClass('icon-Edit') ) {
                    this.expandDriversParent();
                }
            }
        },
        components : {
            ActionMenu
        }
    }
</script>

<style lang="css" scoped>
    .card {
        transition: all 0.3s ease-in-out;
    }

    .card.collapsed {
        display: flex;
        align-items: stretch;
        cursor: pointer;
    }

    .card.collapsed .card__header {
        border-bottom:none;
    }

    .card.collapsed .card__body,
    .card.collapsed .card__footer {
        display: none;
    }

    .portal.mobile .card__header {
        padding-left: 0;
    }

    .portal.mobile .card .card__body {
        padding: relative;
        padding-left: 0;
        padding-right: 0;
    }

    .portal.mobile .card__body .toggle {
        position: absolute;
        top: 1.5em;
        right: 0;
    }

    .portal.mobile .card__body .toggle-hint {
        position: absolute;
        top: calc(1.5em + 3px);
        right: 58px;
        color: #AAAAAA;
    }

    .portal.mobile .card__footer {
        padding-left: 0;
        padding-right: 0;
    }

    .portal.mobile .card__footer .action-menu {
        position: relative;
        right: initial;
        top: initial;
        width: 40px;;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/DriverCard.vue